module.exports = __webpack_public_path__ + "img/faq_factsheet.afe2dd75.png";